export default __webpack_public_path__ + "static/media/eliminate-image.e8aebcde.webp";